export function getProductIdsUsingCollectionIds(campaign) {
  return campaign.productMetas
    .filter(meta => meta.useCollectionIds)
    .map(meta => meta.productId);
}

export function getLineIdsUsingCollectionIds(campaign, campaignLinesById) {
  const productIdsToClean = getProductIdsUsingCollectionIds(campaign);
  return Object.values(campaignLinesById)
    .filter(line => productIdsToClean.includes(line.product.id))
    .map(line => line.id);
}

export function getCampaignLineCreativeIdsToRemove(
  campaignLineCreativesByLineId,
  lineIdsToClean,
) {
  const campaignLineCreativeIdsToRemove = [];
  lineIdsToClean.forEach(lineId => {
    const relatedCampaignLineCreatives =
      campaignLineCreativesByLineId[lineId] || [];
    relatedCampaignLineCreatives.forEach(campaignLineCreative =>
      campaignLineCreativeIdsToRemove.push(campaignLineCreative.id),
    );
  });
  return campaignLineCreativeIdsToRemove;
}
